import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["title", "as", "pageType", "slug", "url"];
import React, { useRef, useState } from 'react';
import { Dropdown } from 'semantic-ui-react';
import { ANGLE_DOWN_ICON, CHEVRON_RIGHT_ICON, DROPDOWN_DIRECTION_LEFT, DROPDOWN_DIRECTION_LEFT_CLASS, DROPDOWN_DIRECTION_OPTIONS, DROPDOWN_DIRECTION_RIGHT, SLIDE_ANIMATION_DURATION } from './DropdownMenu.constants';
import BaseLink from '../../../../../../atoms/Link';
import useResponsive from '../../../../../../hooks/use-responsive/use-responsive';
import { isExternalPage } from '../../../../../../services/pages';
import { AsPropType, SiteNavigationLinkPropType } from '../../../../../../services/proptypes';
import Event, { EVENT_CATEGORIES } from '../../../../../analytics/components/Event';
import { NAVIGATION_MENU_CLICK_EVENT_ACTION } from '../../../../../analytics/components/Event/Event.constants';
import useFixedValueAnimation from '../../../../../animations/hooks/use-fixed-value-animation';
import { HEIGHT_TRANSITION } from '../../../../../animations/types/animation.types';
import FishermanIcon from '../../../../../foundation/components/Icon';
import { cleanLinkProps, sortLinks } from '../../../../services/links';
import { DEFAULT_LINK_AS } from '../Link/Link.constants';
import './DropdownMenu.less';
var defaultProps = {
  linksAs: DEFAULT_LINK_AS,
  className: '',
  dropdownDirection: DROPDOWN_DIRECTION_RIGHT
};
function DropdownMenu(_ref) {
  var title = _ref.title,
    options = _ref.options,
    linksAs = _ref.linksAs,
    className = _ref.className,
    dropdownDirection = _ref.dropdownDirection;
  var dropdownRef = useRef(null);
  var contentRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var sortedOptions = sortLinks(options);
  var cleanedOptions = cleanLinkProps(sortedOptions);
  var _useResponsive = useResponsive(),
    isMobile = _useResponsive.isMobile,
    isTablet = _useResponsive.isTablet;
  var height = open ? 'auto' : 0;
  var _useFixedValueAnimati = useFixedValueAnimation(height, contentRef, HEIGHT_TRANSITION, {
      duration: SLIDE_ANIMATION_DURATION
    }),
    currentHeight = _useFixedValueAnimati.currentValue,
    overflow = _useFixedValueAnimati.overflow;
  function onClick(event) {
    var _ref2 = event || {},
      _ref2$target = _ref2.target,
      target = _ref2$target === void 0 ? {} : _ref2$target;
    if (dropdownRef.current) {
      // dispatches click event as semantic ui will stop propagation of the native one
      window.dispatchEvent(new MouseEvent('click', {
        bubbles: true,
        target: target
      }));
    }
  }
  function showMenu() {
    setOpen(true);
  }
  function hideMenu() {
    setOpen(false);
  }
  var dropdownDirectionClass = dropdownDirection === DROPDOWN_DIRECTION_LEFT ? DROPDOWN_DIRECTION_LEFT_CLASS : '';
  var iconName = isMobile || isTablet ? CHEVRON_RIGHT_ICON : ANGLE_DOWN_ICON;
  var contentStyle = {
    transition: "height ".concat(SLIDE_ANIMATION_DURATION, "ms ease"),
    height: currentHeight,
    overflow: overflow
  };
  return /*#__PURE__*/React.createElement(Dropdown, {
    floating: !!isMobile,
    item: true,
    trigger: /*#__PURE__*/React.createElement("div", {
      className: "divider text"
    }, title),
    className: "dropdown-menu",
    icon: /*#__PURE__*/React.createElement(FishermanIcon, {
      iconName: iconName
    }),
    "aria-label": "dropdown-menu-links",
    ref: dropdownRef,
    onClick: onClick,
    open: open,
    onOpen: showMenu,
    onClose: hideMenu
  }, /*#__PURE__*/React.createElement(Dropdown.Menu, {
    open: open,
    className: dropdownDirectionClass,
    style: contentStyle
  }, /*#__PURE__*/React.createElement("div", {
    ref: contentRef
  }, cleanedOptions.map(function (_ref3) {
    var linkTitle = _ref3.title,
      as = _ref3.as,
      pageType = _ref3.pageType,
      slug = _ref3.slug,
      url = _ref3.url,
      rest = _objectWithoutProperties(_ref3, _excluded);
    return /*#__PURE__*/React.createElement(Event, {
      key: linkTitle,
      event: {
        category: EVENT_CATEGORIES.NAVIGATION_EVENT_CATEGORY,
        action: NAVIGATION_MENU_CLICK_EVENT_ACTION,
        label: linkTitle
      },
      eventType: "click"
    }, /*#__PURE__*/React.createElement(Dropdown.Item, _extends({
      key: linkTitle,
      as: BaseLink,
      to: isExternalPage(pageType) ? url : slug,
      linksAs: as || linksAs,
      title: linkTitle,
      className: className,
      internal: !isExternalPage(pageType),
      role: "option"
    }, rest)));
  }))));
}
DropdownMenu.defaultProps = defaultProps;
export default DropdownMenu;